import { render } from "./LoginUbigeoLocal.vue?vue&type=template&id=e8568652"
import script from "./LoginUbigeoLocal.vue?vue&type=script&lang=js"
export * from "./LoginUbigeoLocal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__